import React, { forwardRef } from "react";
import IconBase, { IconProps } from "frontend/icons/icon-base";

export const MondaySharedBoardIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <IconBase
      ref={ref}
      renderPath={(color: string) => {
        return (
          <>
            <mask
              id="mask0_22379_1292"
              maskUnits="userSpaceOnUse"
              x="3"
              y="5"
              width="14"
              height="11"
              style={{ maskType: "alpha" }}
            >
              <path
                d="M14.5 14.7998V16H5.5V14.7998H14.5ZM15.7998 13.5V7.5C15.7998 6.82688 15.2884 6.27357 14.6328 6.20703L14.5 6.2002H5.5C4.78203 6.2002 4.2002 6.78203 4.2002 7.5V13.5C4.2002 14.218 4.78203 14.7998 5.5 14.7998V16L5.24414 15.9873C4.06772 15.8677 3.13227 14.9323 3.0127 13.7559L3 13.5V7.5C3 6.20566 3.98361 5.14082 5.24414 5.0127L5.5 5H14.5L14.7559 5.0127C16.0164 5.14082 17 6.20566 17 7.5V13.5L16.9873 13.7559C16.8677 14.9323 15.9323 15.8677 14.7559 15.9873L14.5 16V14.7998C15.218 14.7998 15.7998 14.218 15.7998 13.5Z"
                fill={color}
              />
              <path
                d="M7.59961 15L7.58789 15.1211C7.53188 15.3944 7.2899 15.5996 7 15.5996C6.7101 15.5996 6.46811 15.3944 6.41211 15.1211L6.40039 15L6.40039 6C6.40039 5.66863 6.66863 5.40039 7 5.40039C7.33137 5.40039 7.59961 5.66863 7.59961 6L7.59961 15Z"
                fill={color}
              />
            </mask>
            <g mask="url(#mask0_22379_1292)">
              <path d="M11 9H17.5V5H3V16H11V9Z" fill={color} />
            </g>
            <g clipPath="url(#clip0_22379_1292)">
              <path
                d="M17.5498 11.666C17.5498 11.3623 17.3038 11.1162 17 11.1162C16.6962 11.1162 16.4502 11.3623 16.4502 11.666C16.4502 11.9698 16.6962 12.2158 17 12.2158C17.3038 12.2158 17.5498 11.9698 17.5498 11.666ZM18.4502 11.666C18.4502 12.4668 17.8008 13.1162 17 13.1162C16.1992 13.1162 15.5498 12.4668 15.5498 11.666C15.5498 10.8652 16.1992 10.2158 17 10.2158C17.8008 10.2158 18.4502 10.8652 18.4502 11.666Z"
                fill={color}
              />
              <path
                d="M13.5498 13.999C13.5498 13.6953 13.3038 13.4492 13 13.4492C12.6962 13.4492 12.4502 13.6953 12.4502 13.999C12.4502 14.3028 12.6962 14.5488 13 14.5488C13.3038 14.5488 13.5498 14.3028 13.5498 13.999ZM14.4502 13.999C14.4502 14.7998 13.8008 15.4492 13 15.4492C12.1992 15.4492 11.5498 14.7998 11.5498 13.999C11.5498 13.1982 12.1992 12.5488 13 12.5488C13.8008 12.5488 14.4502 13.1982 14.4502 13.999Z"
                fill={color}
              />
              <path
                d="M17.5498 16.334C17.5498 16.0302 17.3038 15.7842 17 15.7842C16.6962 15.7842 16.4502 16.0302 16.4502 16.334C16.4502 16.6377 16.6962 16.8838 17 16.8838C17.3038 16.8838 17.5498 16.6377 17.5498 16.334ZM18.4502 16.334C18.4502 17.1348 17.8008 17.7842 17 17.7842C16.1992 17.7842 15.5498 17.1348 15.5498 16.334C15.5498 15.5332 16.1992 14.8838 17 14.8838C17.8008 14.8838 18.4502 15.5332 18.4502 16.334Z"
                fill={color}
              />
              <path
                d="M13.4734 14.2754C13.5829 14.0876 13.8074 14.0083 14.0057 14.0752L14.0887 14.1133L16.365 15.4395L16.4393 15.4932C16.5953 15.6327 16.6366 15.8678 16.5272 16.0557C16.4175 16.2433 16.1931 16.322 15.9949 16.2549L15.9119 16.2178L13.6356 14.8906L13.5613 14.8369C13.4056 14.6974 13.364 14.4631 13.4734 14.2754Z"
                fill={color}
              />
              <path
                d="M15.992 11.7431C16.1901 11.6763 16.4147 11.7556 16.5242 11.9433C16.6336 12.131 16.592 12.3653 16.4363 12.5048L16.3621 12.5585L14.0887 13.8847L14.0057 13.9228C13.8075 13.9898 13.5831 13.9112 13.4735 13.7236C13.3482 13.5089 13.4209 13.2336 13.6356 13.1083L15.909 11.7812L15.992 11.7431Z"
                fill={color}
              />
            </g>
            <defs>
              <clipPath id="clip0_22379_1292">
                <rect width="8" height="8" fill="white" transform="translate(11 10)" />
              </clipPath>
            </defs>
          </>
        );
      }}
      {...props}
      viewBox="0 0 20 20"
    >
      {props.children}
    </IconBase>
  );
});

MondaySharedBoardIcon.displayName = "MondaySharedBoardIcon";
